import React from 'react';
import { Button, Dropdown, Checkbox, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import './calendar-settings.less';
const CalendarSettings = ({ rootContainer, loading, settings, onToggleEvents, onAddCategory, onAddEvent }) => {
  const syncButtons = [
    ...(!loading
      ? [
          {
            onClick: () => syncGoogleCalendar(),
            label: 'Sync Google',
            key: '4',
          },
        ]
      : []),
    ...(!loading
      ? [
          {
            onClick: () => syncOutlookCalendar(),
            label: 'Sync Outlook',
            key: '5',
          },
        ]
      : []),
  ];

  const syncItems = (
    <div className="calendar-sync-items">
      <Button key="3" size="small" onClick={() => changeTimeZone()}>
        Change time zone
      </Button>
      <Dropdown type="primary" size="small" key="2" trigger={['click']} menu={{ items: syncButtons }} getPopupContainer={rootContainer}>
        <Button key="1" size="small" style={{ marginLeft: 8 }}>
          Sync
          <DownOutlined />
        </Button>
      </Dropdown>
    </div>
  );

  const settingItems = settings && (
    <Space align="baseline" size="small" className="calendar-setting-items">
      {/* <Button size="small" title="Add new calendar category" onClick={($event) => onAddCategory($event)}>
        Add Category
      </Button> */}

      {/* <Button size="small" title="Add new event" onClick={($event) => onAddEvent($event, moment())}>
        Add Event
      </Button> */}

      <Checkbox
        size="small"
        title="Show all event in cell"
        value={settings.showAllEvents}
        checked={settings.showAllEvents}
        onClick={($event) => onToggleEvents($event)}
      >
        Show more events
      </Checkbox>
    </Space>
  );

  return (
    <div className="calendar-scheduler-settings-container">
      {settingItems}
      {/* {syncItems} */}
    </div>
  );
};
export default CalendarSettings;
